import { render, staticRenderFns } from "./CsSolicitudIndex.vue?vue&type=template&id=6a240417"
import script from "./CsSolicitudIndex.vue?vue&type=script&lang=js"
export * from "./CsSolicitudIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports